import React from "react"
import { motion } from "framer-motion"

import Button from "../common/Button"

export default function CTASection() {
  return (
    <section className="relative py-20 lg:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/cta-spa-bg.jpg"
          alt="Bien-être spa de luxe"
          loading="lazy"
          className="w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black/70" />
      </div>

      {/* Decorative Blur */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-[#b8955d]/30 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.span
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="inline-block text-[#d6b57b] uppercase tracking-[5px] text-sm md:text-base font-medium mb-6"
        >
          Réservez Votre Expérience
        </motion.span>

        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight"
        >
          Experience Ultime
          <span className="block text-[#d6b57b]">
            Relaxation & Wellness
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="mt-8 text-base md:text-lg text-gray-200 leading-relaxed max-w-3xl mx-auto"
        >
          Échappez au stress du quotidien et offrez-vous des soins de spa de luxe conçus pour détendre votre corps, rafraîchir votre esprit et rétablir votre équilibre intérieur.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
          viewport={{ once: true }}
          className="flex flex-col sm:flex-row items-center justify-center gap-5 mt-12"
        >
          <Button
            href="https://wa.me/21697902051"
            size="lg"
            variant="primary"
            ariaLabel="Réservez votre rendez-vous au spa via WhatsApp"
          >
            Prendre rendez-vous
          </Button>

          <Button
            to="/services"
            size="lg"
            variant="outline"
            ariaLabel="Explorer les services du spa"
          >
            Explorer Les Services
          </Button>
        </motion.div>

        {/* Bottom Features */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1.4 }}
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-16"
        >
          <div>
            <h3 className="text-3xl font-bold text-[#d6b57b]">
              100%
            </h3>

            <p className="text-gray-300 mt-2 text-sm uppercase tracking-[2px]">
              Relaxation
            </p>
          </div>

          <div>
            <h3 className="text-3xl font-bold text-[#d6b57b]">
              Premium
            </h3>

            <p className="text-gray-300 mt-2 text-sm uppercase tracking-[2px]">
              Traitements
            </p>
          </div>

          <div>
            <h3 className="text-3xl font-bold text-[#d6b57b]">
              Luxe
            </h3>

            <p className="text-gray-300 mt-2 text-sm uppercase tracking-[2px]">
              Expérience
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  )
}